const PREFIX = 'onboarding';
export const ONBOARDING_CHANGE_EVENT = 'itclarifies:onboarding-change';

const storageKey = (name, userId, spaceId) => {
  const base = `${PREFIX}.${name}.${userId || 'anon'}`;
  return spaceId == null || spaceId === '' ? base : `${base}.${spaceId}`;
};

const readFlag = (name, userId, spaceId) => {
  try {
    return window.localStorage.getItem(storageKey(name, userId, spaceId)) === '1';
  } catch {
    return false;
  }
};

const writeFlag = (name, userId, value, { silent = false, spaceId } = {}) => {
  try {
    const key = storageKey(name, userId, spaceId);
    if (value) {
      window.localStorage.setItem(key, '1');
    } else {
      window.localStorage.removeItem(key);
    }
  } catch {
    // Ignore quota / private-mode failures
  }
  if (silent) return;
  try {
    window.dispatchEvent(new Event(ONBOARDING_CHANGE_EVENT));
  } catch {
    // Ignore missing window in tests
  }
};

export const isGettingStartedDismissed = (userId, spaceId) => (
  readFlag('dismissed', userId, spaceId)
);

export const isGettingStartedReplay = (userId, spaceId) => (
  readFlag('replay', userId, spaceId)
);

export const dismissGettingStarted = (userId, spaceId) => {
  writeFlag('replay', userId, false, { silent: true, spaceId });
  writeFlag('dismissed', userId, true, { spaceId });
};

export const resetGettingStarted = (userId, spaceId) => {
  writeFlag('dismissed', userId, false, { silent: true, spaceId });
  writeFlag('replay', userId, true, { spaceId });
};

export const isTipSeen = (tipId, userId) => readFlag(`tip.${tipId}`, userId);

export const markTipSeen = (tipId, userId) => {
  writeFlag(`tip.${tipId}`, userId, true);
};
